import Image from 'next/legacy/image'
import ImageMasthead from 'components/image-masthead'
import { Button, Text } from 'components/atomic'
import { patchNotesUrlSS7 } from 'lib/constants'

const LiveStreamVideoId = '9q0jeAnVTKE'

const onlineCalendars = [
  {
    name: 'Google Calendar',
    src: '/images/icons/google_calendar.svg',
    link: 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20231020T200000Z%2F20231021T020000Z&details=DEADROP%20Snapshot%20VII%20and%20Variant%20Guide%3A%20Series%206%20deploy%20Friday%2C%20October%2020%20at%202pm%20PST.%20Join%20us%20for%20our%20DEADROP%20Snapshot%20VII%20Reveal%20livestream%20event%2C%20where%20we%27ll%20unveil%20the%20new%20Snapshot%20and%20review%20it%20in%20detail%20from%20the%20HyperX%20Arena%20in%20Las%20Vegas%21%20Who%20knows%2C%20we%20might%20even%20give%20a%20sneak%20peek%20at%20things%20to%20come%E2%80%A6%20We%27ll%20be%20streaming%20to%20YouTube%2C%20Kick%2C%20Instagram%2C%20Twitter%2C%20TikTok%2C%20and%20our%20website.%0A%0A%0AYouTube%3A%20https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D9q0jeAnVTKE%0AKick%3A%20https%3A%2F%2Fkick.com%2FMidnightSociety%0ATikTok%3A%20https%3A%2F%2Fwww.tiktok.com%2F%40midnightsociety12am%0AInstagram%3A%20https%3A%2F%2Fwww.instagram.com%2Fmidnightsociety%2F%0ATwitter%3A%20https%3A%2F%2Ftwitter.com%2F12am&location=Hyper%20X%20Arena%2C%20Las%20Vegas%2C%20NV&text=DEADROP%3A%20Snapshot%20VII%20Reveal',
  },
  { name: 'Apple', src: '/images/icons/apple.png', link: '/images/events/DEADROP_Snapshot_VII_Reveal.ics' },
  {
    name: 'Office',
    src: '/images/icons/office.svg',
    link: 'https://outlook.live.com/calendar/0/action/compose?body=DEADROP%20Snapshot%20VII%20and%20Variant%20Guide%3A%20Series%206%20deploy%20Friday%2C%20October%2020%20at%202pm%20PST.%20Join%20us%20for%20our%20DEADROP%20Snapshot%20VII%20Reveal%20livestream%20event%2C%20where%20we%27ll%20unveil%20the%20new%20Snapshot%20and%20review%20it%20in%20detail%20from%20the%20HyperX%20Arena%20in%20Las%20Vegas%21%20Who%20knows%2C%20we%20might%20even%20give%20a%20sneak%20peek%20at%20things%20to%20come%E2%80%A6%20We%27ll%20be%20streaming%20to%20YouTube%2C%20Kick%2C%20Instagram%2C%20Twitter%2C%20TikTok%2C%20and%20our%20website.%0A%0A%0AYouTube%3A%20https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D9q0jeAnVTKE%0AKick%3A%20https%3A%2F%2Fkick.com%2FMidnightSociety%0ATikTok%3A%20https%3A%2F%2Fwww.tiktok.com%2F%40midnightsociety12am%0AInstagram%3A%20https%3A%2F%2Fwww.instagram.com%2Fmidnightsociety%2F%0ATwitter%3A%20https%3A%2F%2Ftwitter.com%2F12am&enddt=2023-10-21T02%3A00%3A00%2B00%3A00&location=Hyper%20X%20Arena%2C%20Las%20Vegas%2C%20NV&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2023-10-20T20%3A00%3A00%2B00%3A00&subject=DEADROP%3A%20Snapshot%20VII%20Reveal',
  },

  {
    name: 'Outlook',
    src: '/images/icons/outlook-2.svg',
    link: 'https://outlook.office.com/calendar/0/action/compose?body=DEADROP%20Snapshot%20VII%20and%20Variant%20Guide%3A%20Series%206%20deploy%20Friday%2C%20October%2020%20at%202pm%20PST.%20Join%20us%20for%20our%20DEADROP%20Snapshot%20VII%20Reveal%20livestream%20event%2C%20where%20we%27ll%20unveil%20the%20new%20Snapshot%20and%20review%20it%20in%20detail%20from%20the%20HyperX%20Arena%20in%20Las%20Vegas%21%20Who%20knows%2C%20we%20might%20even%20give%20a%20sneak%20peek%20at%20things%20to%20come%E2%80%A6%20We%27ll%20be%20streaming%20to%20YouTube%2C%20Kick%2C%20Instagram%2C%20Twitter%2C%20TikTok%2C%20and%20our%20website.%0A%0A%0AYouTube%3A%20https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D9q0jeAnVTKE%0AKick%3A%20https%3A%2F%2Fkick.com%2FMidnightSociety%0ATikTok%3A%20https%3A%2F%2Fwww.tiktok.com%2F%40midnightsociety12am%0AInstagram%3A%20https%3A%2F%2Fwww.instagram.com%2Fmidnightsociety%2F%0ATwitter%3A%20https%3A%2F%2Ftwitter.com%2F12am&enddt=2023-10-21T02%3A00%3A00%2B00%3A00&location=Hyper%20X%20Arena%2C%20Las%20Vegas%2C%20NV&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2023-10-20T20%3A00%3A00%2B00%3A00&subject=DEADROP%3A%20Snapshot%20VII%20Reveal',
  },
  {
    name: 'Yahoo',
    src: '/images/icons/yahoo.png',
    link: 'https://calendar.yahoo.com/?desc=DEADROP%20Snapshot%20VII%20and%20Variant%20Guide%3A%20Series%206%20deploy%20Friday%2C%20October%2020%20at%202pm%20PST.%20Join%20us%20for%20our%20DEADROP%20Snapshot%20VII%20Reveal%20livestream%20event%2C%20where%20we%27ll%20unveil%20the%20new%20Snapshot%20and%20review%20it%20in%20detail%20from%20the%20HyperX%20Arena%20in%20Las%20Vegas%21%20Who%20knows%2C%20we%20might%20even%20give%20a%20sneak%20peek%20at%20things%20to%20come%E2%80%A6%20We%27ll%20be%20streaming%20to%20YouTube%2C%20Kick%2C%20Instagram%2C%20Twitter%2C%20TikTok%2C%20and%20our%20website.%0A%0A%0AYouTube%3A%20https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D9q0jeAnVTKE%0AKick%3A%20https%3A%2F%2Fkick.com%2FMidnightSociety%0ATikTok%3A%20https%3A%2F%2Fwww.tiktok.com%2F%40midnightsociety12am%0AInstagram%3A%20https%3A%2F%2Fwww.instagram.com%2Fmidnightsociety%2F%0ATwitter%3A%20https%3A%2F%2Ftwitter.com%2F12am&et=20231021T020000Z&in_loc=Hyper%20X%20Arena%2C%20Las%20Vegas%2C%20NV&st=20231020T200000Z&title=DEADROP%3A%20Snapshot%20VII%20Reveal&v=60',
  },
]

const SeventhSnapshotRevealPage = () => {
  return (
    <>
      <ImageMasthead image="/images/live-stream/masthead.jpg" className="sm:!min-h-[540px] 3xl:!min-h-[40rem]">
        <div className="mx-auto max-w-[1440px] px-0 pt-32 sm:px-10 md:pt-36 xl:pt-44">
          <Text variant="h2" tag="h2" className="mb-14 text-center">
            DEADROP Snapshot VII Reveal
          </Text>
          <div>
            <div className="mb-2 flex place-content-between">
              <div className="flex">
                <div className="relative mr-1 h-7 w-7 min-w-[28px]">
                  <Image src="/images/deadrop/DEADROP 1.png" layout="fill" objectFit="cover" alt="Deadrop" />
                </div>

                <Text variant="subtitle2" tag="p">
                  LIVESTREAM - Friday, October 20 - 2pm PST
                </Text>
              </div>
              <div className="flex flex-col">
                <Text variant="caption" tag="p">
                  Add to calendar:
                </Text>
                <div className="mt-1 flex">
                  {onlineCalendars.map((item) => (
                    <a
                      href={item.link}
                      key={item.name}
                      className="mr-[21px] flex items-center justify-center"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={item.src} width={25} height={25} alt={item.name} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-3/4">
                <div className="aspect-video">
                  <iframe
                    src={`https://www.youtube.com/embed/${LiveStreamVideoId}`}
                    title="6rd Snapshot Reveal"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="h-full w-full"
                  ></iframe>
                </div>
              </div>
              <div className="lg:w-1/4">
                <div className="h-64 md:h-80 lg:h-full">
                  <iframe
                    src={`https://www.youtube.com/live_chat?v=${LiveStreamVideoId}&embed_domain=${window.location.hostname}`}
                    className="h-full w-full"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="mt-10 flex flex-col justify-evenly md:flex-row">
              <Button href="http://discord.gg/midnight-society" target="_blank" className="mb-4 md:!w-60">
                <span>Join The Discord</span>
              </Button>
              <Button href={patchNotesUrlSS7} target="_blank" className="mb-4 md:!w-60">
                <span>Snapshot VII Patch Notes</span>
              </Button>
              <Button href="/creative" target="_blank" className="mb-4 md:!w-60">
                <span>Learn More About UGC</span>
              </Button>
            </div>
          </div>
        </div>
      </ImageMasthead>
    </>
  )
}

export default SeventhSnapshotRevealPage
